import { render, staticRenderFns } from "./crudSellers.vue?vue&type=template&id=3951ca00&scoped=true&"
import script from "./crudSellers.vue?vue&type=script&lang=js&"
export * from "./crudSellers.vue?vue&type=script&lang=js&"
import style0 from "./crudSellers.vue?vue&type=style&index=0&id=3951ca00&prod&lang=css&"
import style1 from "./crudSellers.vue?vue&type=style&index=1&id=3951ca00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951ca00",
  null
  
)

export default component.exports